import * as React from 'react';

export function UserStarIcon(props) {
  return (
    <svg
      width={22}
      height={22}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11 11a3.667 3.667 0 100-7.333A3.667 3.667 0 0011 11z"
        stroke="#fff"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.583 18.333v-.916a6.417 6.417 0 019.167-5.8M15.248 15.047l.953-2.02a.327.327 0 01.598 0l.952 2.02 2.13.326c.273.042.382.393.184.595l-1.54 1.57.363 2.22c.047.285-.24.502-.484.367L16.5 19.078l-1.905 1.048c-.245.135-.53-.082-.484-.367l.364-2.22-1.54-1.57c-.199-.202-.09-.553.183-.595l2.13-.326z"
        stroke="#fff"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
